import(/* webpackMode: "eager" */ "/opt/build/repo/app/multigrid/page.tsx");
